/* global axios */
import ApiClient from './ApiClient';

class SearchAPI extends ApiClient {
  constructor() {
    super('search', { accountScoped: true });
  }

  get({ q }) {
    return axios.get(this.url, {
      params: {
        q,
      },
    });
  }

  contacts({ q, page = 1, since, until }) {
    return axios.get(`${this.url}/contacts`, {
      params: {
        q,
        page: page,
        since,
        until,
      },
    });
  }

  conversations({
    q,
    page = 1,
    since,
    until,
    status,
    assigneeType,
    assigneeId,
    inboxId,
  }) {
    const params = {
      q,
      page: page,
      since,
      until,
    };
    if (status) params.status = status;
    if (assigneeType) params.assignee_type = assigneeType;
    if (assigneeId) params.assignee_id = assigneeId;
    if (inboxId) params.inbox_id = inboxId;

    return axios.get(`${this.url}/conversations`, {
      params,
    });
  }

  messages({ q, page = 1, since, until, from, inboxId }) {
    return axios.get(`${this.url}/messages`, {
      params: {
        q,
        page: page,
        since,
        until,
        from,
        inbox_id: inboxId,
      },
    });
  }

  articles({ q, page = 1, since, until }) {
    return axios.get(`${this.url}/articles`, {
      params: {
        q,
        page: page,
        since,
        until,
      },
    });
  }
}

export default new SearchAPI();
